import { render } from "./LandingTeatro.vue?vue&type=template&id=25aa5d28"
import script from "./LandingTeatro.vue?vue&type=script&lang=js"
export * from "./LandingTeatro.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__